export const TeamChatPinnedStripTestIds = {
  TOGGLE_BUTTON: 'team-chat.pinned-toggle-button',

  getUnpinButtonId: id => `pinned-strip.unpin-${id}-button`,
};
